export default "__VITE_ASSET__18994527__"